import React from 'react'

import { Icon } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'

import styles from './IconBottleCharacteristics.module.scss'

const IconBottleCharacteristics = ({ text, name }: { text: number | string; name: string }) => {
  return (
    <div className={styles.characteristics}>
      <div className={styles.icon}>
        <Icon name={name} />
      </div>
      <p>{typeof text === 'number' ? formattedText(text) : text}</p>
    </div>
  )
}

export default IconBottleCharacteristics
